<script>
    import { Bar } from 'vue-chartjs'
    // import DashService from "@/_services/DashService"
  export default {
    name:"BarChart",
    extends: Bar,
    props: ['chartdata', 'options'],
    async mounted() {
    await this.renderChart(this.chartdata, this.options,)
    },
  }
</script>